import type { JavascriptRequestDataModel } from 'autogen/swagger/all';
import { useJavascriptRequestDataModelQuery } from 'autogen/swagger/all/hooks';

export default function useWebsiteSettings() {
    const { data } = useJavascriptRequestDataModelQuery({ enabled: false });
    return (data as JavascriptRequestDataModel).websiteSettings;
}
